export default "__VITE_ASSET__okeWBI3X__"